import 'bootstrap/dist/css/bootstrap.css';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/en-ca';

import React, { FC } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import config from 'src/config';

import AppContainer from './AppContainer';
import { useAppTheme } from './shared/hooks';
import { ThemeModeProvider, TranslationProvider } from './shared/providers';
import store from './store';

LicenseInfo.setLicenseKey(config.mui.muiProKey);

const App: FC = () => {
  const { theme, mode, setMode } = useAppTheme();

  return (
    <Provider store={store}>
      <ThemeModeProvider toggleThemeMode={setMode}>
        <ThemeProvider theme={theme}>
          <TranslationProvider>
            <AppContainer />
            <ToastContainer
              className={mode}
              theme="colored"
              position="top-center"
              autoClose={3000}
              newestOnTop={true}
              rtl={false}
              hideProgressBar={true}
              closeOnClick={true}
              pauseOnFocusLoss={false}
              pauseOnHover={false}
              draggable={false}
            />
          </TranslationProvider>
        </ThemeProvider>
      </ThemeModeProvider>
    </Provider>
  );
};

export default App;
